import {Component, OnDestroy, OnInit} from '@angular/core';
import {RubixDocumentsService} from "../../rubix-documents.service";
import {formatBytes} from "../../../../../../shared/util/formatBytes";
import {Subscription} from "rxjs";
import {FileSystemFolderAndDocument} from "../../../../../../../swaggerServices";
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';

@Component({
    selector: 'app-list-view',
    templateUrl: './list-view.component.html',
    styleUrls: ['./list-view.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: 'tax-returns', alias: 'taxReturns' },
        }
    ],
    standalone: false
})
export class ListViewComponent implements OnInit, OnDestroy {

  children: FileSystemFolderAndDocument[] = [];
  loading: boolean;

  subscriptions: Subscription[] = [];

  constructor(
    public rubixDocumentsService: RubixDocumentsService
  ) { }

  ngOnInit(): void {
    this.children = this.rubixDocumentsService.currentFolderDetails.folderChildren;
    this.loading = this.rubixDocumentsService.loading;

    this.subscriptions.push(
      this.rubixDocumentsService.notifyNavigationChange$.subscribe(value => {
        this.loading = this.rubixDocumentsService.loading;
        this.children = this.rubixDocumentsService.currentFolderDetails.folderChildren;
      })
    );

    this.subscriptions.push(
      this.rubixDocumentsService.notifyFolderViewChange$.subscribe(value => {
        this.children = this.rubixDocumentsService.currentFolderDetails.folderChildren;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  isChildSelected(child: FileSystemFolderAndDocument): boolean {
    return this.rubixDocumentsService.isChildSelected(child);
  }

  onCheckboxClick(child: FileSystemFolderAndDocument) {
    this.rubixDocumentsService.toggleSelectChild(child);
  }

  toFolder(folder: FileSystemFolderAndDocument) {
    if (folder.wstype === 'folder') {
      this.rubixDocumentsService.toFolder(folder.id, folder.name);
    }
  }

  getDateString(originalDateString: string): string {
    return originalDateString.substring(0, 10) + ' ' + originalDateString.substring(11, 19);
  }

  getSize(child: FileSystemFolderAndDocument) {
    return formatBytes(child.size, 0);
  }

  getTitle(child: FileSystemFolderAndDocument) {
    if(child.wstype === 'folder') {
      return child.name
    }
    return `${child.name}.${child.extension}`;
  }

}
